import { render, staticRenderFns } from "./user-beastcoin.vue?vue&type=template&id=5bc6ac77&scoped=true&"
import script from "./user-beastcoin.vue?vue&type=script&lang=js&"
export * from "./user-beastcoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6ac77",
  null
  
)

export default component.exports